import * as apis from "@truckdown/jsclient/apis";
import { ILegacySearchService } from "./ILegacySearchService";
import { HoursOfOperationDisplayType } from "./HoursOfOperationDisplayType";
import { HoursOfOperationDisplayTypeModel } from "./HoursOfOperationDisplayTypeModel";
import { SearchResultsDataRequest } from "./SearchResultsDataRequest";

class LegacySearchService implements ILegacySearchService {
    constructor(framework: apis.framework.IFramework) {
        this.framework = framework;
        this.manager = framework.getRequiredService<apis.framework.IWebServiceManager>('IWebServiceManager');
        var alreadyHasService = framework.context.services.has(this.serviceName);

        if (!alreadyHasService) {
            this.setService(framework.context);
        }
    }

    readonly framework: apis.framework.IFramework;
    readonly serviceName: string = 'legacy';

    public getMainUrl(path: string): string {
        return this.framework.context.getServiceUrl(this.serviceName, path);
    }

    private setService(context: apis.framework.IUserContext): void {
        var main = context.services.get(this.manager.main);
        if (main) {
            if (this.isLocal(main)) {
                context.services.set(this.serviceName, {
                    url: 'https://prototype.truckdown.com',
                    alt: 'http://prototype.truckdown.com'
                });
            } else {
                context.services.set(this.serviceName, main);
            }
        }
    }

    private isLocal(service: apis.framework.IWebService): boolean {
        if (service.url.indexOf('localhost') >= 0) {
            return true;
        }
        return false;
    }

    readonly manager: apis.framework.IWebServiceManager;
    private readonly basePath: string = '/hours/data';

    async getHoursData(request: SearchResultsDataRequest): Promise<{ [id: string]: HoursOfOperationDisplayTypeModel }> {
        try {
            let req = this.manager.createRequest({
                service: this.serviceName,
                path: this.basePath,
                method: apis.framework.HttpMethod.POST
            }, request);

            return await this.manager.get<{ [id: string]: HoursOfOperationDisplayTypeModel }>(req);
        } catch (err: unknown) {
            console.log('Exception thrown getting hours data.', err);
            return {};
        }
    }

    async getHoursDataForLocation(locationId: string): Promise<HoursOfOperationDisplayTypeModel> {
        try {
            let req = this.manager.createRequest({
                service: this.serviceName,
                path: this.basePath + encodeURIComponent(locationId),
                method: apis.framework.HttpMethod.GET
            });

            return await this.manager.get<HoursOfOperationDisplayTypeModel>(req);
        } catch(err: unknown) {
            console.log('Exception thrown getting hours data.', err);
            return {
                t: HoursOfOperationDisplayType.Unknown,
                m: ''
            } as HoursOfOperationDisplayTypeModel;
        }
    }
}


export default (framework: apis.framework.IFramework) => {
    framework.registerTransient<ILegacySearchService>('ILegacySearchService', (frm) => {
        return new LegacySearchService(frm);
    });
}